﻿import React, { useContext } from 'react';
import { WaitingListFlowContext } from '../WaitingListFlowContext'

export const Heading = (props) => {
  const { waitingListFlowContext } = useContext(WaitingListFlowContext);
  let headingText = '';
  if (props.text)
    headingText = props.text;
  else if (waitingListFlowContext.activeStep === waitingListFlowContext.overview.index)
    headingText = waitingListFlowContext.localization.waitingListOverview.heading;
  else if (waitingListFlowContext.activeStep === waitingListFlowContext.confirmation.index)
    headingText = '';
  else
    headingText = waitingListFlowContext.facility.name;

  if (headingText.length === 0) {
    return null;
	}

  return (
    <h1 className="waitinglistflowpage__heading">{headingText}</h1>
  )
}
